export const RESET = 'EXSBOWNER_UPDATE_RESET'
export const SET_ERROR = 'EXSBOWNER_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBOWNER_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBOWNER_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBOWNER_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBOWNER_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBOWNER_UPDATE_UPDATE_RETRIEVED'
